import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { patchBodyVisitInformationQueryFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodyVisitInformation/patchBodyVisitInformationQueryFunction';
import { IBodyPatchVisitInformationParams } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodyVisitInformation/patchBodyVisitInformationQuery.type';

export const patchBodyVisitInformationQueryOption = (): MutationOptions<
  AxiosResponse<any, any>,
  Error,
  IBodyPatchVisitInformationParams
> => ({
  mutationKey: ['patchBodySubstitutionPartQueryOption'],
  mutationFn: (params: IBodyPatchVisitInformationParams) =>
    patchBodyVisitInformationQueryFunction(params),
});
